import { useUser } from "@/app/context/UserContext";
import { getcurrentUser } from "@/app/helpers/functions";
import { iActionRequest } from "@/app/models/interfaceChatBotAction";
import { chatbotSaveAction } from "@/app/services/chatbotsaveaction";
import { ChevronDown } from "lucide-react";
import React, { useState, useEffect, useRef } from "react";

interface OptionsFrm {
  label: string;
  value: string;
}

interface SelectChatProps {
  actionCode: string;
  options: OptionsFrm[];
  name?: string;
  value?: string;
  className?: string;
  onChange?: (e: { target: { name?: string; value: string } }) => void;
}

const SelectChat = ({
  actionCode,
  options,
  name,
  value,
  className,
  onChange,
}: SelectChatProps) => {
  const { user, userProject, accessType } = useUser();
  const [searchQuery, setSearchQuery] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [selected, setSelected] = useState(value ?? "");
  const dropdownRef = useRef<HTMLDivElement>(null);

  const filteredOptions = options.filter((opt) =>
    opt.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const handleClear = () => {
    setSearchQuery("");
    setSelected("");
    setShowDropdown(false);
    onChange?.({ target: { name, value: "" } });
  };
  const handleSelect = (option: OptionsFrm) => {
    setSelected(option.value);
    setSearchQuery(option.label);
    setShowDropdown(false);

    onChange?.({ target: { name, value: option.value } });

    if (!user?.email) return;

    const data = name ? { [name]: option.value } : { value: option.value };
    const formObject = {
      target: "select",
      type: "only",
      data,
    };
    const request: iActionRequest = {
      company_code: userProject?.project?.company_code ?? "",
      project_id: userProject?.project?.id ?? "",
      //user_id: user.email,
      user_id: getcurrentUser(accessType, userProject, user),
      action_code: actionCode,
      action_detail: formObject,
    };

    chatbotSaveAction(request).catch((err) =>
      console.error("Error al guardar acción:", err)
    );
  };

  return (
    <div className={`relative w-full `} ref={dropdownRef}>
      <input
        type="text"
        className={` w-full ${className}`}
        placeholder="Seleccione..."
        value={searchQuery}
        onChange={(e) => {
          setSearchQuery(e.target.value);
          setShowDropdown(true);
        }}
        onClick={() => setShowDropdown(true)}
      />
      {searchQuery && (
        <button
          type="button"
          onClick={handleClear}
          className="absolute right-8 top-3 text-gray-500 hover:text-gray-700"
        >
          X
        </button>
      )}
      <ChevronDown className="w-5 h-5 absolute inset-y-0 top-3 right-3 pointer-events-none text-gray-400" /> 
      {showDropdown && (
        <ul className="absolute z-10 w-full bg-white border border-gray-300 mt-1 max-h-60 overflow-auto rounded shadow">
          {filteredOptions.length > 0 ? (
            filteredOptions.map((opt) => (
              <li
                key={opt.value}
                className="px-4 py-2 hover:bg-blue-100 cursor-pointer"
                onClick={() => handleSelect(opt)}
              >
                {opt.label}
              </li>
            ))
          ) : (
            <li className="px-4 py-2 text-gray-400">Sin resultados</li>
          )}
        </ul>
      )}
    </div>
  );
};

export default SelectChat;
